<template>
  <article>
    <span>
      <v-tooltip top :close-delay="500" allow-overflow>
        <v-chip
          slot="activator"
          small
          color="grey darken-1"
          text-color="white"
          @click.native="openTabelaParcela()"
        >{{item}}</v-chip>
        <span>Visualizar tabela de descrição</span>
      </v-tooltip>
    </span>
    <v-dialog @keydown.esc="openDialog = false" v-model="openDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span>
            <strong>Parcelas</strong>
          </span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="openDialog=false">
            <v-icon color="red">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <table border="1" class="table_vencimento">
                  <thead>
                    <tr>
                      <th colspan="3">Opções do simples</th>
                    </tr>
                    <tr>
                      <th colspan="1" style="padding: 5px;">Númeração</th>
                      <th colspan="2">Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(opcao,i) in desc"
                      :key="i"
                      :class="[item == opcao.tipo ? 'destaque_fundo' : '']"
                    >
                      <td class="text-xs-center">{{opcao.tipo}}</td>
                      <td class="text-xs-center">{{opcao.desc}}</td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.stop="openDialog=false">Fechar</v-btn>
          <!-- <v-btn color="success"  @click.stop="newColumn()">Criar</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </article>
</template>
<script>
import { simples } from "@/domain/notas/nfse/util";
export default {
  props: ["item", "table", "component"],
  beforeMount() {},
  data: () => ({
    openDialog: false,
    desc: []
  }),
  methods: {
    openTabelaParcela: function() {
      this.openDialog = true;
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.desc = simples;
    });
  }
};
</script>
<style>
.table_vencimento {
  border-collapse: collapse;
  width: 100%;
}
.table_vencimento td,
.table_vencimento th {
  border: 1px solid black;
}
.table_vencimento td {
  padding: 0px 5px;
}

.destaque_fundo {
  background-color: #00808096;
}
</style>
  



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_simples/Coluna_simples.vue